import hints from './navigation/hints';

export const env = {
  apiBaseUrl: __API_BASE_URL__, // eslint-disable-line no-undef
  fileUploadUrl: __API_FILE_UPLOAD_URL__, // eslint-disable-line no-undef
  producerCode: __12727-001__,  // eslint-disable-line no-undef
  producerCodeLimit: __12727-001_LIMIT__,  // eslint-disable-line no-undef
  production: __PRODUCTION__,
  enableNavigation: __ENABLE_NAVIGATION__,
  servicePortalHost: __SERVICE_PORTAL_HOST__,

  gooleAPI: __GOOGLE_API__,

  //credit payment configuration
  creditCardPaymentConfigId:__CREDIT_CARD_PAYMENT_CONFIG_ID__,
  creditCardPaymentTenant:__CREDIT_CARD_PAYMENT_TENANT__,
  creditCardPaymentApiUrl:__CREDIT_CARD_PAYMENT_API_URL__,
  ...hints
};

if (typeof env.production === 'string') {
  env.production = 'true' === env.production.toLocaleString();
}